<template>
    <div class="">
        <!-- Styles -->
        <div class="col-12 marginBottom">
            <label class="control-label font-size-125 mb-3 textStyle">
                {{ 'Choose a Style' | trans }}
            </label>
        </div>
        <div class="col-12 d-flex flex-wrap rowGap">
            <div class="optionWrapper" v-for="(option, index) in this.conversionOptions"
                @click="optionSelected = option.data_option" :key="index">
                <div class="imageWrapper mb-1">
                    <div :class="optionSelected === option.data_option ? 'checkMark' : 'hidden'">
                        <i class="far fa-check"></i>
                    </div>
                    <img :class="optionSelected === option.data_option ? 'selectedBorder' : ''" class="aiImage"
                        :src="option.image" />
                </div>
                <span class="textStyle">{{ option.name }}</span>
            </div>
        </div>
        <!-- Sizes -->
        <div class="col-12 mt-4 marginBottom">
            <label class="control-label font-size-125 mb-3 textStyle">
                {{ 'Choose a size' | trans }}
            </label>
        </div>
        <div class="col-12 d-flex flex-wrap rowGap">
            <div class="aspectRationBoxOne" :class="sizeSelected === '1:1' ? 'selectedBorder' : ''"
                @click="sizeSelected = '1:1'">
                <span :class="sizeSelected === '1:1' ? 'checkMarkTwo' : 'hidden'">
                    <i class="far fa-check"></i>
                </span>
                <div></div>
                <span class="textStyle">1:1</span>
            </div>
            <div class="aspectRationBoxTwo" :class="sizeSelected === '9:16' ? 'selectedBorder' : ''"
                @click="sizeSelected = '9:16'">
                <span :class="sizeSelected === '9:16' ? 'checkMarkTwo' : 'hidden'">
                    <i class="far fa-check"></i>
                </span>
                <div></div>
                <span class="textStyle">9:16</span>
            </div>
            <div class="aspectRationBoxThree" :class="sizeSelected === '16:9' ? 'selectedBorder' : ''"
                @click="sizeSelected = '16:9'">
                <span :class="sizeSelected === '16:9' ? 'checkMarkTwo' : 'hidden'">
                    <i class="far fa-check"></i>
                </span>
                <div></div>
                <span class="textStyle">16:9</span>
            </div>
        </div>

        <!-- This is to ensure the getOptionsFromForm captures the appropriate data -->
        <div class="hidden">
            <input v-model="this.optionSelected" id="inputStyle" name="style" class="form-control"
                data-options-type="options" data-category="operation" title="" />
            <input id="inputSize" v-model="this.sizeSelected" name="size" class="form-control" data-options-type="options"
                data-category="operation" title="" />
        </div>
    </div>
</template>
<script>
import TransFilter from '../mixins/TransFilter';
import Tooltip from '../form/Tooltip';
import { translate } from '../../../../helper/translate';
export default {
    name: 'AiConversionOptions',
    components: { Tooltip },
    mixins: [TransFilter],
    data() {
        return {
            optionSelected: 'photorealistic',
            sizeSelected: '1:1',
        };
    },
    props: {
        conversionOptions: {
            type: Array,
            default: [
                {
                    name: translate('Realistic'),
                    image: require(`../../../../../../img/ai_images/realistic.jpg`),
                    data_option: 'photorealistic',
                },
                {
                    name: translate('Anime'),
                    image: require(`../../../../../../img/ai_images/anime.jpg`),
                    data_option: 'anime',
                },
                {
                    name: translate('Illustration'),
                    image: require(`../../../../../../img/ai_images/art.jpg`),
                    data_option: 'illustration',
                },
                // {
                //     name: translate('Fantasy'),
                //     image: require(`../../../../../../img/ai_images/generic/01.png`),
                //     data_option: 'fantasy',
                // },
                // {
                //     name: translate('SciFi'),
                //     image: require(`../../../../../../img/ai_images/scifi/01.png`),
                //     data_option: 'scifi',
                // },
            ],
        },
    },
};
</script>
<style scoped>
.imageWrapper {
    width: 110px;
    position: relative;
}

.aiImage {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 7px;
    border: 1px solid #666666;
}

.selectedBorder {
    border: 3px solid #1266f1;
}

.checkMark {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: #1266f1;
    right: 0px;
    position: absolute;
    margin-right: -10px;
    margin-top: -10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.checkMark i {
    color: #fff;
}

.checkMarkTwo {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: #1266f1;
    color: #fff;
    right: 0px;
    position: absolute;
    margin-right: -20px;
    margin-top: -45px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.optionWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}

.textStyle {
    font-weight: 400;
    color: white;
}

.rowGap {
    gap: 21px;
}

.aspectRationBoxOne {
    width: 98px;
    height: 63px;
    display: flex;
    position: relative;
    justify-content: space-evenly;
    align-items: center;
    background-color: #424242;
    border-radius: 8px;
    cursor: pointer;
}

.aspectRationBoxTwo {
    width: 86px;
    height: 63px;
    display: flex;
    position: relative;
    justify-content: space-evenly;
    align-items: center;
    background-color: #424242;
    border-radius: 8px;
    cursor: pointer;
}

.aspectRationBoxThree {
    width: 131px;
    height: 63px;
    display: flex;
    position: relative;
    justify-content: space-evenly;
    align-items: center;
    background-color: #424242;
    border-radius: 8px;
    cursor: pointer;
}

.aspectRationBoxOne div {
    width: 43px;
    height: 43px;
    background-color: #d9d9d9;
    font-size: 17.5px;
}

.aspectRationBoxTwo div {
    width: 21px;
    height: 43px;
    background-color: #d9d9d9;
    font-size: 17.5px;
}

.aspectRationBoxThree div {
    width: 66px;
    height: 43px;
    background-color: #d9d9d9;
    font-size: 17.5px;
}

.marginBottom {
    margin-bottom: 5px;
}
</style>
